import React from "react";

import * as FormControl from "lib/components/FormControl";
import OrderBillItem from "./OrderBillItem";

export default function OrderedFieldOrderBillItem({ orderedField, name, errors, onChange, onFocus, onBlur }) {
  return (
    <OrderBillItem
      {...FormControl.addProps(`${name}.value`, { errors })}
      itemName={orderedField.product_order_field.display_name}
      itemQuantity={orderedField.quantity * orderedField.unit_quantity}
      itemUnitPrice={orderedField.unit_price}
      itemUnitPriceLabel={orderedField.product_order_field.price_label}
      itemTotalPrice={orderedField.price}
    >
      <FormControl.OrderedProductOrderField
        name={`${name}.value`}
        value={orderedField}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        required={false}
      />
    </OrderBillItem>
  );
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderItemsForm/OrderedFieldOrderBillItem.jsx